import React from 'react';
import styled from 'styled-components';
import { media } from '../../../../shared/lib/styles';
import Heading from '../../../../shared/components/Heading';
import Text from '../../../../shared/components/Text';
import { DesktopTitle, TableRow } from '../../../../shared/components/Table';
import { Bundle } from './bundles';
import { BundleTableHeader } from './BundleTableHeader';
import { ProductFeaturesSection } from './ProductFeaturesSection';
import { gutter, space16 } from '../../../../shared/settings/spaces';

const Container = styled.div`
    width: 100%;
    max-width: 1270px;
    flex-shrink: 1;
`;

const Table = styled.table`
    width: 100%;
    // Applied to tr elements directly as grid doesn't nest well
    thead > tr,
    tbody > tr {
        display: grid;
        grid-template-columns: repeat(2, minmax(${space16}px, 500px));
        @media ${media('normal')}, ${media('large')} {
            grid-template-columns: 450px repeat(2, minmax(${space16}px, 1fr));
            grid-column-gap: ${gutter}px;
        }
        grid-column-gap: ${gutter}px;
    }

    // Span heading columns across the table
    th[scope='colgroup'] {
        grid-column: 1 / -1;
    }
`;

export interface Props {
    title: string;
    description: string;
    featureComparison: FeatureComparison;
    bundles: Bundle[];
}
export interface FeatureComparison {
    [index: string]: {
        [index: string]: string;
    };
}

const BundleFeatureComparisonSection = ({
    title,
    description,
    featureComparison,
    bundles,
}: Props) => {
    const numColumns = bundles.length;

    return (
        <>
            <Heading type="h2" variations={['h2', 'with-divider']}>
                {title}
            </Heading>
            <Text style={{ width: '400px' }} baseClass="paragraph" variations={['no-margin']}>
                {description}
            </Text>
            <Container>
                <Table>
                    <thead>
                        <TableRow removeBorder>
                            <DesktopTitle as="th" />
                            {bundles.map((bundle, index) => (
                                <BundleTableHeader key={index} bundle={bundle} />
                            ))}
                        </TableRow>
                    </thead>
                    {Object.keys(featureComparison).map((productId, index, productIds) => {
                        const firstBundleProduct = bundles[0].products[productId];
                        const bundleProducts = bundles.map((bundle) => bundle.products[productId]);

                        return (
                            <ProductFeaturesSection
                                key={index}
                                title={firstBundleProduct.title}
                                logoUrl={firstBundleProduct.logoUrl}
                                bundleProducts={bundleProducts}
                                features={featureComparison[productId]}
                                isLastSection={index === productIds.length - 1}
                            />
                        );
                    })}
                </Table>
            </Container>
        </>
    );
};

export default BundleFeatureComparisonSection;
